import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Styled from 'styled';

import FacebookSDKLoaderView from 'lib/facebook/facebook-sdk-loader-view';
import SVGIconView from 'lib/images/svg-icon-view';

import LoadingWrapperView from 'four-nets/ui/loaders/loading-wrapper-view';
import facebook from 'four-nets/icons/svg/icon_social-facebook.svg';

import SocialButtonView from '../social-button-view';
import defaultStyles from './facebook-button-view.scss';

@Styled(defaultStyles)
@observer
class FacebookButtonView extends React.Component {
    static contextTypes = {
        facebookSDKLoaderView: PropTypes.instanceOf(FacebookSDKLoaderView),
    };

    state = { loading: false };

    onClick = () => {
        if (this.context.facebookSDKLoaderView) {
            this.setState({ loading: true });

            this.context.facebookSDKLoaderView.load().then(() => {
                this.setState({ loading: false });

                const { FB } = window;

                if (FB) {
                    FB.ui(
                        {
                            href: window.location.href,
                            method: 'share',
                        },
                        response => {
                            if (response && !response.error_message) {
                                // pass
                            } else {
                                // pass
                            }
                        }
                    );
                }
            });
        }
    };

    componentWillUnmount() {
        if (this.context.facebookSDKLoaderView) {
            this.context.facebookSDKLoaderView.unrequest();
        }
    }

    render() {
        const { styles, liked, FB, ...rest } = this.props;

        return (
            <LoadingWrapperView
                style={{ loader: styles.loader, loadingWrapper: styles.loadingWrapper, centerer: styles.centerer }}
                loading={this.state.loading}
            >
                <SocialButtonView
                    style={{ button: styles.button }}
                    onClick={this.onClick}
                    {...rest}
                    icon={<SVGIconView src={facebook} />}
                    label={
                        <React.Fragment>
                            <FormattedMessage id='SHARE_VENDOR' /> na Facebook-u
                        </React.Fragment>
                    }
                />
            </LoadingWrapperView>
        );
    }
}

export default FacebookButtonView;
